import React, { Component } from "react";
import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { PrismButton, PrismSwitch } from "@prism-ui/react";
import "./Menu.css";

class Menu extends Component {
  menuRef = React.createRef();
  
  state = {
    open: false,
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    // Close if clicking outside the menu
    if (this.state.open && 
        this.menuRef.current && 
        !this.menuRef.current.contains(event.target)) {
      this.hideMenu();
    }
  };

  hideMenu = () => {
    this.setState({ open: false });
  };

  toggleMenu = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  classNames = () => {
    let open = this.state.open ? "open" : "";
    let alignment = this.props.align ? "text-" + this.props.align : "";
    let collapse = this.props.collapse ? "collapse" : "";
    return open + " " + alignment + " " + collapse;
  };

  endLoginAs = () => {
    this.props.endLoginAs()
    this.hideMenu()
  }

  render = () => {
    let userName = this.props.currentUser?.User.name
    // trim sky title from name
    userName = userName?.replace(/ \(.* Sky - Guest\)$/,'')
    const isSimulated = this.props.currentUser?.simulated
    
    const menuItems = (
      <>
        { isSimulated ? (
          <li className='menu-item menu-item--end-login-as'>
            <PrismButton tone="secondary" size="sm" onPrismClick={this.endLoginAs}>End Login As</PrismButton>
          </li>
        ) : undefined }
        {isSimulated && <li className='menu-divider' role='separator' />}
        {this.props.links.map((link) => (
          <li
            className={`menu-item ${link.special ? "special" : ""}`}
            key={link.name}
            onClick={this.hideMenu}
          >
            {link.external ? (
              <a
                className="nav-link"
                href={link.path}
                title={link.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.icon} {link.name}
              </a>
            ) : (
              <Link to={link.path} className="nav-link">
                {link.icon} {link.name}
              </Link>
            )}
          </li>
        ))}
        { this.props.onThemeChange && (
          <>
            <li className="menu-divider" role="separator" />
            <li className="menu-item menu-item--theme">
              <PrismSwitch
                label="Dark Mode"
                name="theme"
                checked={this.props.currentUser?.User?.theme === 'dark'}
                onPrismChange={(e) => this.props.onThemeChange(e.detail.checked ? 'dark' : 'light')}
              />
            </li>
          </>
        )}
      </>
    );
    
    return (
      <div ref={this.menuRef} className="menu">
        <ul className={`menu-list ${this.classNames()}`}>
          <li className={`menu-item ${!this.props.collapse ? "hidden" : ""}`}>
            <button
              className={`menu-toggle ${this.state.open ? "active" : ""}`}
              onClick={this.toggleMenu}
            >
              {userName ? <span className="menu-current-user">{userName}</span> : this.props.name ? <span className="menu-current-user">{this.props.name}</span> : undefined}
              {this.props.icon ? (
                React.isValidElement(this.props.icon)
                  ? this.props.icon
                  : <FontAwesomeIcon className="icon icon-lg" icon={this.props.icon} />
              ) : null}

              <FontAwesomeIcon
                className="icon"
                icon={this.state.open ? faChevronUp : faChevronDown}
              />
            </button>
          </li>
          {!this.props.collapse ? menuItems : null}
        </ul>
        {this.props.collapse && this.state.open ? (
          <ul className={`menu-dropdown-items ${this.props.align ? "text-" + this.props.align : ""}`}>
            {menuItems}
          </ul>
        ) : null}
      </div>
    );
  };
}

export default Menu;
